module.exports = __webpack_public_path__ + "static/media/pointB.f983961f.png";